/* eslint-disable */

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";

const ScreenSizeWarning = () => {
  return (
    // <div className="flex flex-col w-full h-full items-center just">
    <div className="flex flex-col gap-4 md:hidden w-full max-w-md text-center text-color-dark-text-secondary">
      <i className="fa fa-warning text-3xl" />
      The current screen resolution is insufficient, please consider increasing
      your screen size for an enhanced experience.
    </div>
    // </div>
  );
};

const CirrusBase = () => {
  useEffect(() => {
    document.title = "Cirrus";
  }, []);

  // Update the theme when the user changes it
  const [theme, setTheme] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light",
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => setTheme(mediaQuery.matches ? "dark" : "light");

    mediaQuery.addEventListener("change", handleChange);

    // Cleanup function:
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  useEffect(() => {
    // Disable overscrolling
    document.body.classList.add("overscroll-none");
  }, []);

  return (
    <div className={`${theme} overscroll-none`}>
      <div
        className={`flex flex-col justify-center items-center h-[100dvh] w-screen
        dark:bg-color-dark-background-secondary bg-color-background-secondary
        dark:text-color-dark-text-primary text-color-text-primary overscroll-none
        `}
      >
        <ScreenSizeWarning />
        <div className="hidden md:flex w-full h-[100dvh] overscroll-none">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CirrusBase;
